// extracted by mini-css-extract-plugin
module.exports = {"root":"LocalizedTextTranslator_root__2HPfR","code":"LocalizedTextTranslator_code__397BT","translation":"LocalizedTextTranslator_translation__T22qK"};